import { Check } from "lucide-react";
import { fmtDate } from "@/lib/api";

const ROLE_CLS = { admin: "bg-[#D4AF37]", manufacturer: "bg-[#E06D3B]", customer: "bg-[#A89F91]" };

export function OrderTimeline({ timeline, onConfirm }) {
  return (
    <ol className="relative border-l border-[#D4AF37]/20 ml-2 space-y-6" data-testid="order-timeline">
      {timeline.map((e) => (
        <li key={e.id} className="pl-6 relative" data-testid={`timeline-entry-${e.id}`}>
          <span className={`absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full ${ROLE_CLS[e.by_role]}`} />
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-display text-sm">{e.status}</span>
            <span className="text-[10px] uppercase tracking-[0.15em] text-[#6E6558]">{e.by_role} · {e.by_name}</span>
            {e.by_role === "manufacturer" && (e.confirmed ? (
              <span className="text-[10px] uppercase tracking-[0.15em] text-emerald-400 inline-flex items-center gap-1"><Check className="h-3 w-3" /> confirmed</span>
            ) : onConfirm ? (
              <button onClick={() => onConfirm(e.id)} className="text-[10px] uppercase tracking-[0.15em] rounded-full border border-[#D4AF37]/40 px-2 py-0.5 text-[#F3E5AB] hover:bg-[#D4AF37] hover:text-[#0B0907]" data-testid={`confirm-update-${e.id}`}>
                Confirm &amp; publish
              </button>
            ) : (
              <span className="text-[10px] uppercase tracking-[0.15em] text-[#D4AF37]">awaiting admin</span>
            ))}
          </div>
          {e.note && <p className="text-sm text-[#A89F91] mt-1">{e.note}</p>}
          <p className="text-[11px] text-[#6E6558] mt-1">{fmtDate(e.at)}</p>
        </li>
      ))}
    </ol>
  );
}
